class CustomSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        $(this).css({"opacity":"1"});

         var galleryThumbs = new Swiper(".thumb-slider", {
          spaceBetween: 10,
          direction: "horizontal",
          slidesPerView: 3.6,
          navigation: {
            nextEl: ".slider__next",
            prevEl: ".slider__prev",
          },
          breakpoints: {
            0: {
              slidesPerView:3.6,
              spaceBetween: 10,
              direction: 'horizontal',
            },
            768: {
              slidesPerView:5,
              spaceBetween: 10,
              direction: 'vertical', 
            },
            1024: {
              slidesPerView: 5,
              spaceBetween: 10,
              direction: 'vertical',
            },
            1441: {
              slidesPerView: 6,
              spaceBetween: 10,
              direction: 'vertical', 
            }
          },
        });
          
        var galleryTop = new Swiper(".main-slider", {
          spaceBetween: 10, 
          direction: "horizontal",
          thumbs: {
            swiper: galleryThumbs
          },
          breakpoints: {
            0: {
              slidesPerView: 1,
              spaceBetween: 10,
              direction: 'horizontal',
            },
            768: {
              slidesPerView: 1,
              spaceBetween: 10,
              direction: 'horizontal', 
            }
          },
        });
    
          galleryTop.on("slideChangeTransitionStart", function () {
            galleryThumbs.slideTo(galleryTop.activeIndex);
          });
          galleryThumbs.on("transitionStart", function () {
            galleryTop.slideTo(galleryThumbs.activeIndex);
          });
    
          $('.pr-swiper-image').mouseenter(function(){
            $('.swiper-slide').find('.pr-swiper-image').removeClass('pr-img-img')
            $(this).parent('.swiper-slide').find('.pr-swiper-image').addClass('pr-img-img');
            $('.pr-img-img').zoom();
          });
    
        $('[data-fancybox="gallery"]').fancybox({
          buttons: [
            "slideShow",
            "thumbs",
            "zoom",
            "fullScreen",
            "share",
            "close"
          ],
          loop: false,
          protect: true
        });
        
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 400px 0px",
      }).observe(this);
    }
  
}

customElements.define("custom-slider", CustomSlider);


class CustomLogoSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        $(this).css({"opacity":"1"});
        var autoplay = $(this).data('autoplay');
        var slideperrow = $(this).data('logoperrow');
        var slideperrowmob = $(this).data('logoperrowmob');
        
        var swiper = new Swiper(".customlogoimages--" + this.getAttribute("data-sectionid"), {
          slidesPerView: "auto",
          spaceBetween:25,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          autoplay: {
            enabled: autoplay,
            delay:0,          
            disableOnInteraction: false,
          },
          speed:2500,   
          loop:autoplay,
          breakpoints: {
            640: {
              slidesPerView: "auto",
              spaceBetween:25,
            },
            768: {
              slidesPerView: "auto" ,
              spaceBetween:25,
            },
            1024: {
              slidesPerView: "auto",
              spaceBetween:40,
            },
            1441: {
              slidesPerView: "auto",
              spaceBetween:80,
            },
          }
        });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 400px 0px",
      }).observe(this);
    }
  }
  customElements.define("custom-logo-slider", CustomLogoSlider);


class CustomAwardSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        $(this).css({"opacity":"1"});
        var autoplay = $(this).data('autoplay');
        var slideperrow = $(this).data('logoperrow');
        var slideperrowmob = $(this).data('logoperrowmob');
        
        var swiper = new Swiper(".customlogoimages--" + this.getAttribute("data-sectionid"), {
          slidesPerView: slideperrowmob,
          spaceBetween:25,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          autoplay: {
            enabled: autoplay,
            delay:0,          
            disableOnInteraction: false,
          },
          speed:2500,   
          loop:autoplay,
          breakpoints: {
            640: {
              slidesPerView: slideperrowmob,
              spaceBetween:25,
            },
            768: {
              slidesPerView: slideperrow - 2,
              spaceBetween:25,
            },
            1024: {
              slidesPerView: slideperrow - 1,
              spaceBetween:40,
            },
            1441: {
              slidesPerView: slideperrow,
              spaceBetween:80,
            },
          }
        });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 400px 0px",
      }).observe(this);
    }
  }
  customElements.define("custom-award-slider", CustomAwardSlider);


    class CustomImageSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        $(this).css({"opacity":"1"});
        var autoplay = $(this).data('autoplay');
        var swiper = new Swiper(".customimagetextslider--" + this.getAttribute("data-sectionid"), {
          slidesPerView: 1,
          spaceBetween:20,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          autoplay:autoplay,
          loop:autoplay,
          breakpoints: {
            640: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 4,
            },
            1441: {
              slidesPerView: 5,
            },
          }
        });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 400px 0px",
      }).observe(this);
    }
  }
  customElements.define("custom-image-slider", CustomImageSlider);


    class CustomReviews extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        $(this).css({"opacity":"1"});
        var autoplay = $(this).data('autoplay');
        var swiper = new Swiper(".customreviewslider--" + this.getAttribute("data-sectionid"), {
          slidesPerView: 1,
          spaceBetween:30,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          autoplay:autoplay,
          loop:autoplay,
          breakpoints: {
            640: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            990: {
               slidesPerView: 3,
            },
            1024: {
              slidesPerView: 3,
            }
          }
        });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 400px 0px",
      }).observe(this);
    }
  }
  customElements.define("custom-reviews", CustomReviews);


   class CustomImageTextBox extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        $(this).css({"opacity":"1"});
        var autoplay = $(this).data('autoplay');
        var slideCount = $(this).find('.swiper-slide').length || 1;
        var swiper = new Swiper(".customimagetextboxslider--" + this.getAttribute("data-sectionid"), {
          slidesPerView: Math.min(1, slideCount),
          spaceBetween:30,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          autoplay:autoplay,
          loop:autoplay,
          breakpoints: {
            640: {
              slidesPerView: Math.min(1, slideCount),
            },
            768: {
              slidesPerView: Math.min(3, slideCount),
            },
            1024: {
              slidesPerView: Math.min(3, slideCount),
            },
            1441: {
              slidesPerView: Math.min(4, slideCount),
            },
          }
        });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 400px 0px",
      }).observe(this);
    }
  }
  customElements.define("custom-image-text-box", CustomImageTextBox);


  class CustomProductInfo extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
  
        var blockid = $(this).data('block_id');
        var faqheading = $('.custom-collapse-heading-'+blockid);
           
        $(faqheading).click(function(e) {
            e.preventDefault();
    
        
          let $this = $(this);
        
          if ($this.next().hasClass('show')) {
              $this.next().removeClass('show');
              $this.next().slideUp(350);
              
              $this.find('.fa-collapse-arrows').find('.fa-collapse-plus').css({"display":"flex"});
              $this.find('.fa-collapse-arrows').find('.fa-collapse-minus').css({"display":"none"});
          } else {
              $this.parent().parent().find('.faq-collapse-answers').removeClass('show');
              $this.parent().parent().find('.faq-collapse-answers').slideUp(350);
        
              $this.parent().parent().find('.fa-collapse-arrows').find('.fa-collapse-plus').css({"display":"flex"});
              $this.parent().parent().find('.fa-collapse-arrows').find('.fa-collapse-minus').css({"display":"none"});
            
              $this.next().toggleClass('show');
              $this.next().slideToggle(350);
            
              $this.find('.fa-collapse-arrows').find('.fa-collapse-plus').css({"display":"none"});
              $this.find('.fa-collapse-arrows').find('.fa-collapse-minus').css({"display":"flex"});
          }
        });
      
     }
  
    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
  }
  
  customElements.define('custom-product-info', CustomProductInfo);


  class CustomSizeGuide extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      $('.clicksizeguide').click(function(){
        $('.custom-size-guide-container').show();
        $('.overlay-custom').show();
        $('html').css({"overflow-y":"hidden"});
      });

      $('.size-guide-close').click(function(){
        $('.custom-size-guide-container').hide();
        $('.overlay-custom').hide();
        $('html').css({"overflow-y":"unset"});
        
      });

      $('.overlay-custom').click(function(){
        $('.custom-size-guide-container').hide();
        $(this).hide();
        $('html').css({"overflow-y":"unset"});
        
      });
      
     }
  
    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
   }
  }
  customElements.define('custom-size-guide', CustomSizeGuide);



   class CustomAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        $(this).css({"opacity":"1"});
        var autoplay = $(this).data('autoplay');
        var effect = $(this).data('effect');
        var speedtime = $(this).data('speedtime');
        
        var swiper = new Swiper(".custom-announcement--" + this.getAttribute("data-sectionid"), {
          slidesPerView: 1,
          spaceBetween:30,
          effect: effect,
          fadeEffect: { crossFade: true },
          autoplay: {
            enabled: autoplay,
            delay:speedtime,          
            disableOnInteraction: false,
          },
          loop:autoplay,
        });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 400px 0px",
      }).observe(this);
    }
  }
  customElements.define("custom-announcement-slider", CustomAnnouncementBar);